import React, { useEffect } from 'react'
import styles from './styles.module.scss'
import Button from '../../components/Button'
import Li from '../../components/Li'
import { IoIosAdd } from 'react-icons/io'
import { thrash } from '../../assets/svg/other'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import { useState } from 'react'
// import Modal from './Modal' // старая модалка отключена, см. ModalSimple
import Modal from './ModalSimple'
import { Pagination } from '../../components/Pagination'
import { deleteSchoolYear, setPage, getSchoolYearsList } from '../../actions/schoolYears'
import Table from '../../components/Table'
import { getTypesStudySessions } from '../../actions/directory'


export default function TypesStudySessions() {

  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [selectedItem, setSelectedItem] = useState(null)

  const { typesStudySessions } = useSelector(state => state.directory)

  useEffect(() => {
    dispatch(getTypesStudySessions());
    dispatch(setPage(0));
  }, [])


  const openModal = (data) => () => {
    setSelectedItem(data || {})
  }

  const closeModal = () => setSelectedItem(null)

  const goHome = () => navigate('/')

  // const thrashClickHandler = (id) => (e) => {
  //   e.stopPropagation()
  //   dispatch(deleteSchoolYear(id))
  // }

  const renderBool = (value) => (
    <td className={value ? styles.yes : styles.no}>{value ? 'Да' : 'Нет'}</td>
  )

  const renderLi = (data) => {
    const { typename, isavailable, isavailabledo, isavailablevd, fixed_weight, default_weight, is_used, istest } = data
    return (
      <tr onClick={openModal(data)}>
        <td>{typename}</td>
        {renderBool(isavailable)}
        {renderBool(isavailabledo)}
        {renderBool(isavailablevd)}
        {renderBool(is_used)}
        <td>{default_weight}</td>
        {renderBool(fixed_weight)}
        {renderBool(istest)}
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '1500px', margin: '0 auto' }}>
      <Modal
        closeModal={closeModal}
        data={selectedItem}
      />
      <header className={styles.header}>
        <h1>Типы учебных занятий</h1>
      </header>
      <main className={styles.content}>
        <Table className={styles.table} maxHeight="75vh">
          <thead>
            <tr>
              <th>Тип учебного процесса</th>
              <th>Основное</th>
              <th>Дополнительное</th>
              <th>ВД</th>
              <th>Используется</th>
              <th>Вес оценок</th>
              <th>Редактирование веса</th>
              <th>Участие в КОУ, СОУ, % усп.</th>
            </tr>
          </thead>
          <tbody>
            {typesStudySessions?.map(renderLi)}
          </tbody>
        </Table>
        <div className={styles.actions}>
          <span className={styles.counter}>Всего записей: {typesStudySessions?.length || 0}</span>
        </div>
      </main>
    </div>
  )
}
